import React from 'react';
import {
  Card, CardBody,
} from 'reactstrap';
import _ from 'lodash';
import Button from 'app/components/general/Button';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import Isvg from 'react-inlinesvg';
import base64 from 'base-64';

import CrossIcon from 'app/images/icons/cross.svg';

import IActions from 'app/types/actions';
import connectionProviders from 'app/utils/static/connectionProviders';
import TeammoLogo from 'app/images/teammo-logo.svg';

import gamedaySports from 'app/utils/static/gamedaySports';


interface IConnectFormProps {
  actions?: IActions;
  email: string;
  password: string;
  isLoading?: boolean;
  hasLoaded?: boolean;
  hasFailed?: boolean;
  isLoggedIn?: boolean;
  backendErrors: any;
  match: any;
}

interface IConnectFormState {
  email?: string;
  password?: string;
  backendErrors?: any;
  errors: any;
  changed: boolean;
}

export default class ConnectForm extends React.Component<
  IConnectFormProps,
  IConnectFormState
> {
  static defaultProps: IConnectFormProps = {
    email: '',
    password: '',
    isLoading: false,
    backendErrors: {},
  };

  componentDidMount = (): void => {
    if (!_.isEmpty(this.props.match?.params?.prefilled)) {
      const prefilled = JSON.parse(base64.decode(this.props.match?.params?.prefilled));
      const sportsId = prefilled.sportsName;
      let sportsSelections = { id: gamedaySports[sportsId], name: gamedaySports[sportsId] };
      if (this.props.match.params?.provider === 'gameday' && !_.isEmpty(prefilled.sportsName) && !_.isEmpty(gamedaySports[sportsId])) {
        sportsSelections = { id: gamedaySports[sportsId], name: gamedaySports[sportsId] };
      }
      const fullName = prefilled.fullName || prefilled.fullname;
      const payload = {
        organisationName: prefilled.organisationName,
        gamedayOrganisationId: prefilled.gamedayOrganisationId,
        fullName,
        email: prefilled.email,
        provider: this.props.match?.params?.provider,
        sport: sportsSelections,
      };
      this.props.actions.setConnectInformation(payload);
    }
  }

  render(): React.ReactNode {
    const providerKey = this.props.match.params?.provider;
    const providerName = connectionProviders[providerKey]?.name;
    const providerLogo = connectionProviders[providerKey]?.logo;
    return (
      <div>
        <div className="row">
          <div className="col">
            <Card className="extra-shadow">
              <CardBody className="with-extra-padding-2">
                <div className="row with-margin-top">
                  <div className="col">
                    <div className="connection-logo-container">
                      <img
                        className="logo d-none d-sm-inline-block"
                        alt="Teammo"
                        src={TeammoLogo}
                      />
                    </div>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col">
                    <div className="connection-logo-container">
                      <Isvg className="cross-icon" src={CrossIcon} />
                    </div>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col">
                    <div className="connection-logo-container">
                      <img className="connection-logo" alt={providerName} src={providerLogo} />
                    </div>
                  </div>
                </div>
                <div className="row with-margin-top">
                  <div className="col">
                    <span className="text-dark-grey medium-text">Connect Teammo to your GameDay Passport for syncing fixture and team contact data.</span>
                  </div>
                </div>
                <div className="row with-margin-top">
                  <div className="col">
                    <Button
                      color="primary"
                      className="btn-1 btn-full-width large"
                      tabIndex="2"
                      noLoading
                      onClick={() => history.push('/get-started/connect/gameday')}
                    >
                      Create a new Teammo account
                    </Button>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col text-center">
                    <span className="text-grey text-center medium-text">or</span>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col">
                    <Button
                      color="primary"
                      className="btn-2 btn-full-width large"
                      tabIndex="1"
                      noLoading
                      onClick={() => {
                        if (this.props.authentication.isAuthenticated) {
                          history.push('/create-connection/gameday');
                        } else {
                          history.push('/login/connect/gameday');
                        }
                      }}
                    >
                      I have an existing Teammo account
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        <div className="row justify-content-center sign-up">
          <div className="col text-center with-margin-bottom-10">
            <span className="d-inline-block text-grey">Don't have an account?</span>
            {' '}
            <Link to="/get-started">Sign up</Link>
          </div>
        </div>
      </div>
    );
  }
}
